import { create } from 'zustand'
import { IssueTypeT } from '@/components/common/menu/lib/types/navigationDataTypes.ts'
import { ProjectStageStoreT } from '@/components/common/menu/lib/store/projectStageStoreTypes.ts'
import somethingWrong from '@/lib/helpers/somethingWrong.ts'
import { NavigationItemT } from '@/lib/types/navigationTypes.ts'
import createIssueTypesLinks from '@/lib/helpers/createIssueTypesLinks.tsx'
import createIri from '@/lib/helpers/createIri.ts'
import { useLocallyStoredFilters } from '@/routes/projectStages/issues/lib/stores/useLocallyStoredFilters.ts'

export const useProjectStageStore = create<ProjectStageStoreT>(set => ({
  currProjectStage: null,
  iri: null,
  setCurrProjectStage: currProjectStage =>
    set(() => {
      const iri = createIri(`project_stages`, currProjectStage.id)
      // console.log(`setting project stage`, currProjectStage.id)
      return { currProjectStage, iri }
    }),
  issueTypes: [],
  currIssueType: null,
  currIssueTypeIri: null,
  setIssueTypes: issueTypes =>
    set(state => {
      // console.log(`setIssueTypes`)
      const currIssueType = state.currIssueType ?? issueTypes[0]
      const currIssueTypeIri = state.currIssueTypeIri ?? createIri(`issue_types`, currIssueType.id)
      state.setProjectStageIssuesLinks(issueTypes)
      return { issueTypes, currIssueType, currIssueTypeIri }
    }),
  setCurrIssueType: iri =>
    set(state => {
      const found = state.issueTypes.find(i => {
        const issueTIri = createIri(`issue_types`, i.id)
        return issueTIri === iri
      })
      // console.log(`issue type iri`, iri)
      // console.log(state.issueTypes)
      // console.log({ found }, `setting issue type`)
      const labels = found?.labelGroups?.flatMap(group => group.labels ?? [])
      return {
        currIssueType: found,
        currIssueTypeLabels: labels,
      }
    }),
  projectStageIssuesLinks: [],
  setProjectStageIssuesLinks: (currStageIssueTypes: IssueTypeT[]) =>
    set(state => {
      // console.log(`setProjectStageIssuesLinks`, state.currProjectStage)
      const { projectStageIssuesLinks, unreadNotificationsCount } = createIssueTypesLinks(
        state.currProjectStage,
        currStageIssueTypes,
      )

      // console.log(`createIssueTypesLinks`, projectStageIssuesLinks?.[0])
      // console.log(`links created`, projectStageIssuesLinks)
      return { projectStageIssuesLinks, unreadNotificationsCount }
    }),
  currIssueTypeLabels: [],
  unreadNotificationsCount: 0,
  setAllUnreadNotificationsCount: unreadNotificationsCount => set({ unreadNotificationsCount }),
  updateNotificationsCountByIssueType: (issueTypeIri, count) =>
    set(state => {
      // console.log(`updateNotificationsCountByIssueType`)
      const index = state.projectStageIssuesLinks.findIndex(
        link => link.issueTypeIri === issueTypeIri,
      )

      if (index === -1) {
        somethingWrong()
        return state
      }

      const newLinks: NavigationItemT[] = state.projectStageIssuesLinks.map(link => {
        if (link.issueTypeIri !== issueTypeIri) return link
        return {
          ...link,
          notifications: count,
        }
      })

      return { projectStageIssuesLinks: newLinks }
    }),
  updateLinkPath: (issueTypeIri: string, path: string) =>
    set(state => {
      // console.log(`updateLinkPath`, issueTypeIri, path)
      const index = state.projectStageIssuesLinks.findIndex(
        link => link.issueTypeIri === issueTypeIri,
      )

      // console.log(state.projectStageIssuesLinks)
      if (index === -1) {
        console.error(`not found aborting ❌`)
        return state
      }

      const newLinks: NavigationItemT[] = state.projectStageIssuesLinks.map(link => {
        if (link.issueTypeIri !== issueTypeIri) return link
        return {
          ...link,
          link: path,
        }
      })

      newLinks[index].link = path

      useLocallyStoredFilters.getState().updateProjectStageIssuesLinks(newLinks)

      return { projectStageIssuesLinks: newLinks }
    }),
  resetStageStore: () =>
    set({
      currProjectStage: null,
      issueTypes: [],
      currIssueType: null,
      projectStageIssuesLinks: [],
    }),
  queueCount: 0,
  queueRequests: [],
  setQueueRequests: queueRequests =>
    set(() => {
      return { queueRequests, queueCount: queueRequests.length }
    }),
}))
